import { createStore } from 'vuex'
import auth from './modules/auth'
import products from './modules/products'
import categories from './modules/categories'
import locations from './modules/locations'
import inventory from './modules/inventory'
import transactions from './modules/transactions'
import warehouses from './modules/warehouses'
import zones from './modules/zones'
import analytics from './modules/analytics'
import tour from './modules/tour'
import edition from './modules/edition'
import { useToast } from 'vue-toastification'

export default createStore({
  state: {
    notifications: []
  },
  actions: {
    showError({ commit }, message) {
      const toast = useToast()
      toast.error(message)
    },
    showSuccess({ commit }, message) {
      const toast = useToast()
      toast.success(message)
    }
  },
  modules: {
    auth,
    products,
    categories,
    locations,
    inventory,
    transactions,
    warehouses,
    zones,
    analytics,
    tour,
    edition
  }
})
